module.exports = __webpack_public_path__ + "img/pamela-nagami-md.313c5e7d.png";